import type { FortuneIconProps } from '@/app_components/icons/constants';

export const Pinterest = ({ className, ...props }: FortuneIconProps) => {
  return (
    <svg
      className={className}
      height='20'
      stroke='none'
      viewBox='0 0 20 20'
      width='20'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <title>Pinterest icon</title>
      <mask
        height='20'
        id='mask0_543_44084'
        maskUnits='userSpaceOnUse'
        style={{ maskType: 'alpha' }}
        width='20'
        x='0'
        y='0'
      >
        <rect
          fill='#D9D9D9'
          height='20'
          width='20'
        />
      </mask>
      <g mask='url(#mask0_543_44084)'>
        <path
          d='M17.1429 0H2.85714C1.28125 0 0 1.28125 0 2.85714V17.1429C0 18.7188 1.28125 20 2.85714 20H6.09821L6 19.9643C5.75893 17.817 5.86161 17.3973 6.70089 13.9509C6.875 13.2366 7.08036 12.3884 7.32143 11.3661C7.32143 11.3661 6.99554 10.7054 6.99554 9.73661C6.99554 6.58036 10.3661 6.25446 10.3661 8.62054C10.3661 9.22321 10.125 10.0089 9.86607 10.8438C9.71875 11.317 9.57143 11.8036 9.45982 12.2723C9.20536 13.3661 10.0089 14.2545 11.0848 14.2545C13.0357 14.2545 14.5312 12.2009 14.5312 9.23661C14.5312 6.61161 12.6429 4.77679 9.95089 4.77679C6.83036 4.77679 5 7.11607 5 9.53572C5 10.4777 5.36607 11.4866 5.81696 12.0357C5.90625 12.1429 5.91964 12.2366 5.89286 12.3482C5.84375 12.558 5.75446 12.9241 5.68304 13.2054C5.63839 13.3839 5.60268 13.5312 5.58929 13.5893C5.54018 13.7902 5.43304 13.8348 5.22321 13.7366C3.85714 13.0982 3 11.0982 3 9.49107C3 6.03125 5.50893 2.85714 10.2411 2.85714C14.0446 2.85714 17 5.56696 17 9.1875C17 12.9643 14.6205 16.0045 11.3125 16.0045C10.2009 16.0045 9.15625 15.4286 8.79911 14.7455C8.79911 14.7455 8.25 16.8393 8.11607 17.3527C7.89286 18.2143 7.33036 19.2679 6.89286 20H17.1429C18.7188 20 20 18.7188 20 17.1429V2.85714C20 1.28125 18.7188 0 17.1429 0Z'
          fill='currentColor'
        />
      </g>
    </svg>
  );
};
